import { z } from 'zod';
import { passwordSchema } from './PasswordValidationSchema';

const allowedEmailDomains = [
  'gmail.com',
  'wp.pl',
  'onet.pl',
  'interia.pl',
  'o2.pl',
  'poczta.onet.pl',
  'poczta.fm',
  'tlen.pl',
  'op.pl',
  'gazeta.pl',
  'test.test',
  'test.pl',
];

const emailDomainValidator = (email: string) => {
  const domain = email.split('@')[1]?.toLowerCase();
  return allowedEmailDomains.includes(domain || '');
};

const emailSchema = z
  .string({ required_error: 'Email jest wymagany' })
  .min(1, 'Email jest wymagany')
  .email('Niepoprawny format adresu email')
  .max(64, 'Email jest zbyt długi')
  .refine(emailDomainValidator, {
    message:
      'Dozwolone domeny: gmail.com, wp.pl, onet.pl, interia.pl, o2.pl, poczta.onet.pl, poczta.fm, tlen.pl, op.pl, gazeta.pl',
  });

export const RegisterZodSchema = z
  .object({
    email: emailSchema,
    password: passwordSchema,
    confirmPassword: z
      .string({ required_error: 'Potwierdzenie hasła jest wymagane' })
      .min(1, 'Potwierdzenie hasła jest wymagane'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Hasła nie są identyczne',
    path: ['confirmPassword'],
  });

export type RegisterFormValues = z.infer<typeof RegisterZodSchema>;
